/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Booking_Link_InvalidInputs */

const en_error_booking_link_invalid = /** @type {(inputs: Error_Booking_Link_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This booking link is not valid any more.`)
};

/**
* | output |
* | --- |
* | "This booking link is not valid any more." |
*
* @param {Error_Booking_Link_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_booking_link_invalid = /** @type {((inputs?: Error_Booking_Link_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Booking_Link_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_booking_link_invalid(inputs)
});